<!--
 * @Description: 需求签收【采购计划管理】
 * @FilePath: \ShiMo_Mobile\src\views\purchase\demandSignForReceipt\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="demandSignForReceipt commonListStyles">
            <HeaderNav
                header-title="需求签收"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">需求签收单编号：{{ item.allocation_number }}</span>
                                    </h4>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>汽运单编号：{{ item.ysd_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>供货单编号：{{ item.supply_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_2@2x.png" alt="">
                                            <span>供货日期：{{ item.supply_date }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>供应商：{{ item.supplier_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>需求部门：{{ item.apply_dept_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>物料短描述：{{ item.material_short_names }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>核对人：{{ item.check_user_name1 }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>到场时间：{{ item.check_time1 }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>签收状态：{{ item.status_name }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn">
                                        <button @click="openDetailFun(item)" v-if="item.status === 1">
                                            编辑
                                        </button>
                                        <button @click="openDetailFun(item)" v-else>
                                            查看
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'requirement-approval',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'requirement-approval');
        }
        next();
    },
    data() {
        return {
            tableCode: 'cg_ysd_xqqs',
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    methods: {
        // 打开编辑
        openDetailFun(data) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'demandSignForReceiptForm',
                params: {
                    data: data,
                },
            });
        },
        // 打开合同审批页
        openApprovalProcess(data) {
            data.BusinessInstanceId = data.business_instance_id;
            this.$router.isBack = 2;
            this.$router.push({
                name: 'approvalProcess',
                params: {
                    data: data,
                    isReadOnly: data.apply_status === 1 ? false : true,
                    platformEnterprises: data.tenant_id,
                },
            });
        },

    },
};
</script>
<style lang="stylus">
.demandSignForReceipt
    section
        .van-pull-refresh
            height: calc(100% - 42rpx) !important
</style>
